/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse20013DataStudentSignedPermission from './InlineResponse20013DataStudentSignedPermission';

/**
 * The InlineResponse20013Data model module.
 * @module model/InlineResponse20013Data
 * @version 1.0.0
 */
class InlineResponse20013Data {
    /**
     * Constructs a new <code>InlineResponse20013Data</code>.
     * @alias module:model/InlineResponse20013Data
     */
    constructor() { 
        
        InlineResponse20013Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20013Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20013Data} obj Optional instance to populate.
     * @return {module:model/InlineResponse20013Data} The populated <code>InlineResponse20013Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20013Data();

            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('student_signed_permission')) {
                obj['student_signed_permission'] = InlineResponse20013DataStudentSignedPermission.constructFromObject(data['student_signed_permission']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} version
 */
InlineResponse20013Data.prototype['version'] = undefined;

/**
 * @member {String} content
 */
InlineResponse20013Data.prototype['content'] = undefined;

/**
 * @member {module:model/InlineResponse20013DataStudentSignedPermission} student_signed_permission
 */
InlineResponse20013Data.prototype['student_signed_permission'] = undefined;






export default InlineResponse20013Data;

